/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { AuthGetUrlLineResponse } from "./AuthGetUrlLineResponse";

export type AuthGetUrlLineResponseApiRespoonse = {
  data?: AuthGetUrlLineResponse;
  status?: AuthGetUrlLineResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace AuthGetUrlLineResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
